import type { SvgProps } from "../types";

export const BusSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bus</title>
      <path
        d="M343.354 166.313C342.226 150.616 344.209 127.229 331.855 114.853C307.199 90.1461 243.835 97.1562 213.984 97.1562C179.745 97.1562 106.943 90.6429 78.1569 100.257C45.8857 111.04 51.1104 247.131 55.1637 265.394"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M69.1728 205.655C154.496 212.537 251.974 194.529 336.23 215.611C344.736 217.743 351.345 264.623 346.177 271.524C345.682 272.18 307.953 267.692 303.324 267.692C228.194 267.692 152.968 264.633 78.3578 264.633"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M337.159 163.165C242.797 169.913 149.349 152.314 55.2339 152.314"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M330.185 181.747C330.185 191.043 330.185 200.334 330.185 209.63"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M284.537 170.904C286.907 182.557 283.329 194.652 282.097 204.983"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M229.497 167.804C229.497 179.162 229.497 190.519 229.497 201.883"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M163.62 169.354C163.211 178.132 163.095 186.981 162.156 195.688"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M110.104 161.608C109.505 176.503 107.847 190.665 114.098 201.883"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M104.837 110.49C104.963 123.923 105.441 137.361 106.306 150.765"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M160.525 107.393C159.145 119.43 159.057 150.728 159.057 155.413"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M210.389 105.843C209.239 120.884 210.389 135.731 210.389 150.765"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M253.024 101.196C252.956 119.47 253.69 137.373 254 155.413"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M295.333 107.393C295.333 122.37 295.333 137.338 295.333 152.315"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M118.528 255.728C111.466 245.382 100.599 238.366 87.6555 241.271C50.2704 249.667 90.0475 315.808 111.753 290.736C119.846 281.389 122.858 271.526 121.541 259.535"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M326.906 262.748C309.571 217.401 251.476 263.283 282.72 294.488C306.381 318.119 331.816 293.983 329.231 268.168"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
